import {
  getdiscount,
  getpromotioncode,
  getviewDiscount,
  getviewPromotion,
  getDiscountTemplate,
  creatediscount,
  editViewdiscount,
  editdiscount,
  getPromotioncodeTemplate,
  createpromotioncode,
  editpromotioncode,
  editViewPromotionCode,
  deleteDiscount,
  deletePromotioncode,
} from "@/http/setup/discountPromotion.js";

export default {
  namespaced: true,
  state: {
    itemTemplate: {},
    discountList: [],
    promotionCodeList: [],
    viewDiscountList: [],
    viewPromotionList: [],
    DiscountTemplateList: {},
    createDiscountList: null,
    ViewEditDiscount: [],
    PromotionTemplateList: {},
    editViewPromotion: [],
  },
  actions: {
    async setItemTemplate({ commit }) {
      try {
        const sup = await itemDataTemplate();
        commit("ITEM_DATA_TEMPLATE", sup.data);
        return sup;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setdiscount({ commit }) {
      try {
        const resp = await getdiscount();
        commit("SET_DISCOUNT", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setpromotioncode({ commit }) {
      try {
        const resp = await getpromotioncode();
        commit("SET_PROMOTION_CODE", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setviewDiscount({ commit }, id) {
      try {
        const resp = await getviewDiscount(id);
        commit("SET_VIEW_DISCOUNT", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setviewPromotion({ commit }, id) {
      try {
        const resp = await getviewPromotion(id);
        commit("SET_VIEW_PROMOTION", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setDiscountTemplate({ commit }) {
      try {
        const resp = await getDiscountTemplate();
        commit("SET_DISCOUNT_TEMPLATE", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async creatediscountAction({ commit }, data) {
      try {
        const resp = await creatediscount(data);
        commit("CREATE_DISCOUNT_ACTION", resp.data.resourceId);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async seteditViewdiscount({ commit }, id) {
      try {
        const resp = await editViewdiscount(id);
        commit("SET_EDIT_VIEW_DISCOUNT", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editdiscountAction({ commit }, data) {
      try {
        const resp = await editdiscount(data.id, data.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setPromotioncodeTemplate({ commit }) {
      try {
        const resp = await getPromotioncodeTemplate();
        commit("SET_PROMOTION_CODE_TEMPLATE", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editpromotioncodeAction({ commit }, data) {
      try {
        const resp = await editpromotioncode(data.id, data.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createpromotioncodeAction({ commit }, data) {
      try {
        const resp = await createpromotioncode(data);
        commit("CREATE_PROMOTIONCODE_ACTION", resp.data.resourceId);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async seteditViewPromotionCode({ commit }, id) {
      try {
        const resp = await editViewPromotionCode(id);
        commit("SET_EDIT_VIEW_PROMOTION_CODE", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteDiscountAction({ commit }, id) {
      try {
        const resp = await deleteDiscount(id);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deletePromotioncodeAction({ commit }, id) {
      try {
        const resp = await deletePromotioncode(id);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mutations: {
    ITEM_DATA_TEMPLATE(state, payload) {
      state.itemTemplate = payload;
    },
    SET_DISCOUNT(state, payload) {
      state.discountList = payload;
    },
    SET_PROMOTION_CODE(state, payload) {
      state.promotionCodeList = payload;
    },
    SET_VIEW_DISCOUNT(state, payload) {
      state.viewDiscountList = payload;
    },
    SET_VIEW_PROMOTION(state, payload) {
      state.viewPromotionList = payload;
    },
    SET_DISCOUNT_TEMPLATE(state, payload) {
      state.DiscountTemplateList = payload;
    },
    CREATE_DISCOUNT_ACTION(state, payload) {
      state.createDiscountList = payload;
    },
    SET_EDIT_VIEW_DISCOUNT(state, payload) {
      state.ViewEditDiscount = payload;
    },
    SET_PROMOTION_CODE_TEMPLATE(state, payload) {
      state.PromotionTemplateList = payload;
    },
    CREATE_PROMOTIONCODE_ACTION(state, payload) {
      state.createPromotioncodeList = payload;
    },
    SET_EDIT_VIEW_PROMOTION_CODE(state, payload) {
      state.editViewPromotion = payload;
    },
  },
  getters: {},
};
